import { removeStyle } from './removeStyle';
import { isAutoPx } from './utils/isAutoPx';
import { camelize } from './utils/string';
import { rcustomProp } from './utils/css/rcustomProp';

export interface CSSProperty {
  [key: string]: string | number;
}

const _addStyle = (
  elem: HTMLElement,
  name: string,
  value?: string | number) => {
  if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) {
    return;
  }

  const origName = camelize(name);
  const style = elem.style;
  //是否为自定义属性，一般都是用变量称，如：--xxx-xxx-xxx
  const isCustomProp = rcustomProp.test(name);

  //const isCustomProp = rcustomProp.test( name )
  if (value !== undefined) {
    const type = typeof value;

    if (value == null || value !== value) {
      return;
    }
    if (type === "number") {
      value += isAutoPx(origName) ? "px" : "";
    }

    if (isCustomProp) {
      style.setProperty(name, value.toString());
    } else {
      style[name as any] = value.toString();
    }
  }
}
export const addStyle = (
  elem: string | HTMLElement | NodeListOf<HTMLElement> | HTMLElement[],
  property: string | Partial<CSSProperty>,
  value?: string | number
): void => {
  const elements =
    typeof elem === "string" ? document.querySelectorAll<HTMLElement>(elem) :
      elem instanceof HTMLElement ? [elem] : elem;

  elements.forEach(e => {
    if (typeof property === "string") {
      _addStyle(e, property, value)
    } else {
      Object.entries(property).forEach(([key, val]) => {
        _addStyle(e, key, val)
      });
    }
  });
}